import React from 'react'
import * as S from './styles'
import { getImage, ImageDataLike } from 'gatsby-plugin-image'
import { StrapiFile } from '@shared/utils/strapi/strapi.types'

interface ZoomInModalProps {
  readonly image: StrapiFile & { localFile?: ImageDataLike }
  readonly showModal: boolean
  readonly onClose: () => void
}

const ZoomInModal:React.FC<ZoomInModalProps> = ( { image, showModal, onClose } ): React.ReactElement | null => {
  if ( !showModal ) {
    return null
  }

  const isImageFromGatsby = Boolean( image.localFile )

  return (
    <S.ModalOverlay
      role="dialog"
      onClick={ () => onClose() }
    >
      <S.ModalContent onClick={ e => e.stopPropagation() }>
        <S.CloseButton
          onClick={ () => onClose() }
          aria-label="Fechar modal"
        >
        ×
        </S.CloseButton>
        <S.ModalImageWrapper>
          {isImageFromGatsby ? (
            <S.ModalImageGatsby
              image={ getImage( image.localFile! )! }
              alt="Imagem ampliada"
            />
          ) : (
            <S.ModalImage
              src={ image.url }
              alt="Imagem ampliada"
            />
          )}
        </S.ModalImageWrapper>
      </S.ModalContent>
    </S.ModalOverlay>
  )
}

export default ZoomInModal
